<template>
  <div class="search-form">
    <form @submit.prevent="setSearchTerm()">
      <FormKit
        id="the-search-input"
        ref="searchInput"
        v-model="searchTerm"
        inner-class="formkit-input-element--search"
        name="the-search-input"
        placeholder="Search"
        type="search"
      />
      <FormKit
        v-if="showButton"
        id="the-search-button"
        input-class="search-button"
        label="Go"
        name="the-search-button"
        type="submit"
      />
    </form>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  showButton?: boolean
}>()
const emit = defineEmits(['onSearch'])
const { searchTerm, setSearchTerm } = useSearch({
  showButton: props.showButton,
  onSearch: () => {
    emit('onSearch')
  },
})
</script>

<style lang="less" scoped>
:deep(.formkit-outer[data-family='button'] .search-button) {
  .font-bold();

  .button-color(
    @color-secondary,
    @color-text-reverse,
    @color-secondary,
    @color-text-reverse,
    @color-fill-normal,
    @color-secondary,
    @color-secondary,
    @color-secondary,
  );
}

:deep(input[type='search']) {
  border-radius: 0;
}
</style>
